import { MessageListSkeleton } from '../MessageList/skeleton';
import { default as ConversationListSkeleton } from '../ConversationList/skeleton';
import { default as RenterProfileSkeleton } from '../InboxSidebar/skeleton';
import { default as ConversationNavSkeleton } from '../ConversationNav/skeleton';
import {
  InboxGlobalStyle,
  StyledColumnWrapper,
  StyledPageContent,
  StyledPrimaryColumn,
  StyledTertiaryColumn,
} from '../../styles/inboxPageStyles';
import StyledSecondaryColumn from '../SecondaryColumn';
import Layout from '../Layout';
import InboxHeaderSkeleton from '../InboxHeader/skeleton';
import { ConversationSearchBarSkeleton } from '../SearchBar/Skeleton';

const InboxPageSkeleton = () => {
  return (
    <Layout showFooter={false}>
      <InboxGlobalStyle />

      <StyledPageContent>
        <InboxHeaderSkeleton />

        <StyledColumnWrapper>
          <StyledPrimaryColumn $shouldHideOnMobile={false} style={{ overflow: 'hidden' }}>
            <ConversationSearchBarSkeleton />
            <ConversationListSkeleton />
          </StyledPrimaryColumn>

          <StyledSecondaryColumn shouldHideOnMobile={true}>
            <ConversationNavSkeleton />
            <MessageListSkeleton />
          </StyledSecondaryColumn>

          <StyledTertiaryColumn $shouldHideOnMobile={true}>
            <RenterProfileSkeleton />
          </StyledTertiaryColumn>
        </StyledColumnWrapper>
      </StyledPageContent>
    </Layout>
  );
};

export default InboxPageSkeleton;
